import React from "react";
import OutsideClickHandler from "react-outside-click-handler";

import { faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment, { type Moment } from "moment";

import { DueDate } from "~/common";
import { DatePicker } from "~/common/DatePicker";

import styles from "./css/styles.module.css";

export const ExpirySelect: React.FunctionComponent<{
	onClose: () => void;
	removeDate: () => void;
	date?: Moment;
	updateDate: (d: Moment) => void;
	hideHeader?: boolean;
}> = ({ onClose, updateDate, date, removeDate, hideHeader }) => {
	return (
		<>
			<OutsideClickHandler onOutsideClick={onClose}>
				<div className={styles.datePicker}>
					{(!hideHeader || date) && (
						<div className="duedate-topbar">
							<div className="duedate-back-button">
								<div className="icon" onClick={onClose}>
									<FontAwesomeIcon icon={faTimes} />
								</div>
							</div>
							<div className="duedate-due">
								{date ? (
									<>Expiry {<DueDate as="span" styled={false} date={date.format("YYYY-MM-DD")}></DueDate>}</>
								) : (
									<span>No expiry set</span>
								)}
							</div>
							<div className="duedate-action">{date && <button onClick={removeDate}>remove</button>}</div>
						</div>
					)}

					<DatePicker
						firstSelectableDate={moment()}
						onDateChange={updateDate}
						visibleMonth={date ? date : moment()}
						date={date}
						key={1}
					/>
				</div>
			</OutsideClickHandler>
		</>
	);
};
